/*jslint browser: true */
/*global window, require */

const jstz = require('jstz')
const winAlias = window
const docAlias = winAlias.document

module.exports = {
    setAccount: function (tracker, cmd) {
        if (cmd.length === 0) {
            return false
        }

        tracker.queue.addDefault('a', cmd.shift())
    },

    setService: function (tracker, cmd) {
        if (cmd.length === 0) {
            return false
        }

        tracker.queue.addDefault('srv', cmd.shift())
    },

    setAccountService: function (tracker, cmd) {
        if (cmd.length === 0) {
            return false
        }

        tracker.queue.addDefault('as', cmd.shift())
    },

    setEndpoint: function (tracker, cmd) {
        if (cmd.length === 0) {
            return false
        }

        tracker.transport.setEndpoint(cmd.shift())
    },

    setObject: function (tracker, cmd) {
        const obj = cmd.shift() || {}

        if (obj.hasOwnProperty('id') && obj.hasOwnProperty('type')) {
            tracker.hasPageObject = true
            tracker.queue.addDefault('obj', obj)
        }
    },

    resetPage: function (tracker) {
        tracker.hasPageObject = false
    },

    setKeys: function (tracker, cmd) {
        const keys = cmd.shift() || []
        const outputKeys = []

        const validTypes = [
            'Proposal',
            'Contact',
            'Listing',
            'Agent',
            'DprApprasial',
            'DprLead',
            'DprReport',
            'Note',
            'Proposal',
            'AppInstall',
            'Offer',
            'Viewing',
            'ProspectiveBuyer',
            'Object',
        ]

        if (Array.isArray(keys) && keys.length) {
            keys.forEach(function (element) {
                const id = element?.id
                const idType = element?.idType || element?.type

                if (id && idType && validTypes.includes(idType)) {
                    outputKeys.push({
                        id,
                        idType,
                    })
                }
            })
        }

        tracker.queue.addDefault('keys', outputKeys)
    },

    trackPageview: function (tracker, cmd) {
        let item = tracker.queue.create()
        item.cmd = 'pv'

        item.host = winAlias.location.host

        item.sx = parseInt(winAlias.screen.width, 10) || 0
        item.sy = parseInt(winAlias.screen.height, 10) || 0
        item.tz = jstz.determine().name()
        item.p = winAlias.location.pathname
        item.r = docAlias.referrer || ''

        if (!tracker.hasPageObject) {
            let obj = {
                id: item.p,
                type: 'page',
                title: docAlias.title,
            }

            if (!(typeof obj === 'string' || obj instanceof String)) {
                let tmp = docAlias.getElementsByTagName('title')
                if (tmp && typeof tmp !== 'undefined') {
                    obj.title = tmp[0].text
                }
            }

            tracker.queue.addDefault('obj', obj)
        }

        tracker.queue.send(item)

        // Start Pinging
        //setInterval(function() {
        //    tracker.push(["ping"]);
        //}, 30 * 1000);
    },

    ping: function (tracker, cmd) {
        let item = tracker.queue.create()
        item.cmd = 'ping'

        tracker.queue.send(item)
    },

    triggerEvent: function (tracker, cmd) {
        if (cmd.length != 2) {
            return false
        }

        cmd = cmd.shift()
        let item = Object.assign(cmd.shift(), tracker.queue.create())
        item.cmd = cmd

        tracker.queue.send(item)
    },
}
